import { useQuery } from "@tanstack/react-query";

/**
 * รูปร่างของแผนที่สถิติ — `map-geo.json` (~130KB gzip) โหลดแยกเฉพาะตอนเปิด Dashboard
 *
 * สร้างจาก SDS-Admin-Mockup ห้ามแก้ด้วยมือ:
 * - ขอบเขตเมืองทั่วประเทศ = geoBoundaries gbOpen LAO ADM2 ปี 2019 (CC BY 3.0 IGO — ต้องแสดงที่มาทุกครั้งที่วาด)
 *   จับคู่ชื่อกับ `apps/api/data/lao_admin.csv` แล้ว; เมืองที่ตั้งหลังปี 2019 / แถวซ้ำ ไม่มีรูป (จอบอกไว้)
 * - ขอบเขตแขวง = รวมเมืองของแขวงเดียวกัน (ตัดขอบที่ใช้ร่วมกัน)
 * - ขอบเขตตาแสง = **โดยประมาณ** มีเฉพาะนครหลวงฯ (ยังไม่มีข้อมูล GIS จริง จอต้องบอกไว้เสมอ)
 *
 * พิกัดเป็นพิกเซลโลก Web-Mercator ที่ zoom 12 จึงวาง tile ของ OSM/Esri ใน SVG เดียวกันได้
 * key: แขวง = รหัสแขวง (`01`), เมือง = รหัสเมือง (`0101`), ตาแสง = `รหัสเมือง/รหัสตาแสง` (`0106/SVL`) ตรงกับ DB
 */

export interface Shape {
  /** path SVG */
  d: string;
  /** จุดวางป้าย */
  c: [number, number];
  /** กรอบ [x0, y0, x1, y1] */
  bb: [number, number, number, number];
}

export interface MapGeo {
  river: string;
  attribution: string;
  provinces: Record<string, Shape>;
  districts: Record<string, Shape>;
  tasaengs: Record<string, Shape>;
}

/** zoom ของพิกัดใน MapGeo */
export const GEO_ZOOM = 12;

export type MapMode = "country" | "province" | "district";

/** รูปของพื้นที่ลูกตามระดับ — ไม่มีรูป = undefined (จอบอกไว้ใต้แผนที่) */
export function shapeOf(geo: MapGeo, mode: MapMode, code: string, districtCode?: string): Shape | undefined {
  if (mode === "country") return geo.provinces[code];
  if (mode === "province") return geo.districts[code];
  return geo.tasaengs[`${districtCode ?? ""}/${code}`];
}

export function useMapGeo() {
  return useQuery({
    queryKey: ["map-geo"],
    queryFn: async () => (await import("./map-geo.json")).default as unknown as MapGeo,
    staleTime: Infinity,
  });
}
